<div class="wk-cm__header-jobsummary-wrapper" role="button" aria-hidden="true" (click)="handleOpenInApp($event)">
    <!-- prettier-ignore -->
    <a class="wk-cm__header-jobsummary"
        >({{ jobsBillingCard()?.job?.id }} @if (jobTypeShortCode()) {{{ jobTypeShortCode() }}} @if (jobsBillingCard()?.job?.periodEndDate) { {{ jobsBillingCard()!.job.periodEndDate * 1000 | date: "yyyy-MM-dd" }}})</a
    >
    <span class="wk-cm__header-jobsummary-icon">
        <wk-icon-link-external-sprite-pds3 />
        <icon-pds3 name="wk-icon-link-external" />
    </span>
</div>
